import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Profile from './pages/Profile';
import FaqCategories from './pages/FaqCategories';
import Faq from './pages/Faq';
import Settings from './pages/Settings';
import Clients from './pages/Clients';
import ClientChat from './pages/ClientChat';
import StopWords from './pages/StopWords';
import PrivateRoute from './components/PrivateRoute';
import Users from './pages/Users';
import Accounts from './pages/Accounts';
import Agents from './pages/Agents';
import ChatwootTeams from './pages/ChatwootTeams';
import History from './pages/History';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path="/faq-categories"
        element={
          <PrivateRoute>
            <FaqCategories />
          </PrivateRoute>
        }
      />
      
      <Route
        path="/faq"
        element={
          <PrivateRoute>
            <Faq />
          </PrivateRoute>
        }
      />
      <Route
        path="/faq/:categoryId"
        element={
          <PrivateRoute>
            <Faq />
          </PrivateRoute>
        }
      />
     
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />

      <Route
        path="/clients"
        element={
          <PrivateRoute>
            <Clients />
          </PrivateRoute>
        }
      />
      <Route
        path="/clients/:clientId"
        element={
          <PrivateRoute>
            <ClientChat />
          </PrivateRoute>
        }
      />

      <Route
        path="/stop-words"
        element={
          <PrivateRoute>
            <StopWords />
          </PrivateRoute>
        }
      />

      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Users />
          </PrivateRoute>
        }
      />
      <Route
        path="/accounts"
        element={
          <PrivateRoute>
            <Accounts />
          </PrivateRoute>
        }
      />
      <Route
        path="/agents"
        element={
          <PrivateRoute>
            <Agents />
          </PrivateRoute>
        }
      />
      <Route
        path="/chatwoot-teams"
        element={
          <PrivateRoute>
            <ChatwootTeams />
          </PrivateRoute>
        }
      />
      <Route
        path="/history"
        element={
          <PrivateRoute>
            <History />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;